import React, { Component } from 'react';

import Header from './Header';
import PageTitle from './PageTitle';

class Page extends Component {
    render() {
        return (
            <div className={"pp-page " + (this.props.pageClass ? this.props.pageClass : '')}>
                <Header />
                <div className="pp-page-content">
                    {(this.props.pageTitle || this.props.pageActions) &&
                        <PageTitle pageTitle={this.props.pageTitle} pageActions={this.props.pageActions} />
                    }
                    { this.props.children }
                </div>
            </div>
        );
    }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js